import React from 'react';
import PropTypes from 'prop-types';
import { FormGroup, Input, Label } from 'reactstrap';
import * as Icon from 'react-feather';
import { getIn } from 'formik';

const FormFileUpload = ({
  className = '',
  label,
  name,
  value,
  placeholder = 'Choose file',
  accept = '.pdf,.xlsx,.xls,.docx',
  touched,
  errors,
  setFieldValue,
  onBlur
}) => {
  const fieldTouched = getIn(touched, name);
  const fieldError = getIn(errors, name);
  const isError = fieldTouched && fieldError;

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      setFieldValue(name, file);
    }
  };

  return (
    <FormGroup className={`${className} position-relative`}>
      <Label htmlFor={name}>{label}</Label>
      <div className="file-upload-container">
        <Input
          type="text"
          className={`file-name ${isError ? 'is-invalid' : ''}`}
          placeholder={value ? value.name : placeholder}
          readOnly
        />
        <label className="upload-button" htmlFor={name}>
          <Icon.Upload size={18} />
          <Input
            type="file"
            id={name}
            name={name}
            className="file-upload d-none"
            accept={accept}
            onChange={handleFileChange}
            onBlur={onBlur}
          />
        </label>
      </div>
      {isError && <span className="invalid-feedback d-block">{fieldError}</span>}
    </FormGroup>
  );
};

FormFileUpload.propTypes = {
  className: PropTypes.string,
  label: PropTypes.string,
  name: PropTypes.string,
  value: PropTypes.any,
  placeholder: PropTypes.string,
  accept: PropTypes.string,
  touched: PropTypes.object,
  errors: PropTypes.object,
  setFieldValue: PropTypes.func,
  onBlur: PropTypes.func
};

export default FormFileUpload;
